import { Link } from "react-router-dom";
import styled from "styled-components";
import { useAuthStore } from "../../stores/auth.store";
import { getShopCartQuantity, useShopCartStore } from "../../stores/shopCart.store";
import { useShopAccess } from "../../pages/shop/useShopAccess";
import { ShopBagIcon } from "./ShopBagIcon";

export type SidebarProps = {
  isOpen: boolean;
  onClose: () => void;
};

const SidebarContainer = styled.aside<{ $isOpen: boolean }>`
  position: fixed;
  top: 60px; // Start below the header (assuming header height is 60px)
  right: 0;
  bottom: 0;
  width: 100%; // Full width
  background: #000;
  color: white;
  transform: translateY(
    ${(props) => (props.$isOpen ? "0" : "100%")}
  ); // Change to Y axis
  transition: transform 0.3s ease;
  z-index: 90; // Lower than header's z-index (100)
`;

const NavMenu = styled.nav`
  margin: 40px 0;
  justify-content: space-between; // This will distribute space between items
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 600px; // Optional: limit width of menu items
  margin-left: auto;
  margin-right: auto;
`;

const NavLink = styled(Link)`
  color: white;
  display: block;
  font-size: 18px;
  padding: 15px 20px;
  text-align: center;
  text-decoration: none;

  &:hover {
    background: #333;
  }
`;

const ShopMenuContent = styled.span`
  align-items: center;
  display: inline-flex;
  gap: 14px;
  justify-content: center;
`;

const formatShopCartBadgeQuantity = (quantity: number) => {
  if (quantity <= 0) {
    return null;
  }

  if (quantity > 9) {
    return "9+";
  }

  return String(quantity);
};

export const Sidebar = ({ isOpen, onClose }: SidebarProps) => {
  const { authUser } = useAuthStore();
  const cartQuantity = useShopCartStore((state) => {
    return getShopCartQuantity(state.items);
  });
  // The cart belongs to tesserati only, so nobody else sees the bag.
  const canUseCart = useShopAccess() === "member";
  const cartBadgeLabel = canUseCart
    ? formatShopCartBadgeQuantity(cartQuantity)
    : null;

  return (
    <SidebarContainer $isOpen={isOpen}>
      <NavMenu>
        <NavLink to="/home" onClick={onClose}>
          HOME
        </NavLink>
        {authUser ? (
          <NavLink to="/account" onClick={onClose}>
            IL MIO ACCOUNT
          </NavLink>
        ) : (
          <>
            <NavLink to="/login" onClick={onClose}>
              LOGIN
            </NavLink>
            <NavLink to="/register" onClick={onClose}>
              REGISTRATI
            </NavLink>
          </>
        )}
        <NavLink to="/shop" onClick={onClose}>
          <ShopMenuContent>
            <span>SHOP</span>
            {canUseCart && <ShopBagIcon badgeLabel={cartBadgeLabel} size={28} />}
          </ShopMenuContent>
        </NavLink>
        <NavLink to="/conventions" onClick={onClose}>
          CONVENZIONI
        </NavLink>
      </NavMenu>
    </SidebarContainer>
  );
};
